document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-edo-purchase]').forEach(function (wrapper) {

    var productForm = wrapper.querySelector('[data-edo-product-form]');
    var variantInput = wrapper.querySelector('[data-edo-variant-id]');
    var submitButton = wrapper.querySelector('[data-edo-submit]');
    var status = wrapper.querySelector('[data-edo-status]');
    var freightBox = wrapper.querySelector('[data-edo-freight]');
    var freightEmail = wrapper.querySelector('[data-edo-freight-email]');
    var variantsJSON = wrapper.querySelector('[data-edo-variants]');

    if (!productForm || !variantInput || !submitButton || !variantsJSON) return;

    var variants;

    try {
      variants = JSON.parse(variantsJSON.textContent);
    } catch (error) {
      console.error('EDO Shipping: No se pudieron leer las variantes.', error);
      return;
    }


    /* -----------------------------------
       NORMALIZAR TEXTO
    ----------------------------------- */

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/,/g, '.')
        .replace(/\s+/g, ' ')
        .trim();
    }


    /* -----------------------------------
       OPCIONES SELECCIONADAS
    ----------------------------------- */

    function selectedOptions() {

      var section = wrapper.closest('.shopify-section') || document;

      var controls = section.querySelectorAll(
        'variant-selects select,' +
        'variant-selects input[type="radio"]:checked,' +
        'variant-radios input[type="radio"]:checked'
      );

      return Array.from(controls).map(function (control) {
        return normalize(control.value);
      });
    }


    /* -----------------------------------
       ENCONTRAR VARIANTE ACTUAL
    ----------------------------------- */

    function currentVariant() {

      var optionValues = selectedOptions();

      if (optionValues.length) {

        var byOptions = variants.find(function (variant) {

          return (
            variant.options.length === optionValues.length &&
            variant.options.every(function (option, index) {
              return normalize(option) === optionValues[index];
            })
          );

        });

        if (byOptions) return byOptions;
      }


      /*
       * Buscar el ID que utiliza actualmente
       * el formulario del tema.
       */

      var section = wrapper.closest('.shopify-section') || document;

      var themeInputs = section.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"]'
      );

      for (var input of themeInputs) {

        if (input === variantInput || !input.value) continue;

        var byInput = variants.find(function (variant) {
          return String(variant.id) === String(input.value);
        });

        if (byInput) return byInput;
      }


      /*
       * Variante indicada en la URL
       */

      var urlId = new URLSearchParams(window.location.search).get('variant');

      if (urlId) {

        var byUrl = variants.find(function (variant) {
          return String(variant.id) === String(urlId);
        });

        if (byUrl) return byUrl;
      }


      /*
       * Último recurso
       */

      return (
        variants.find(function (variant) {
          return String(variant.id) === String(variantInput.value);
        }) ||
        variants.find(function (variant) {
          return variant.available;
        }) ||
        variants[0]
      );
    }


    /* -----------------------------------
       ENVÍO ESPECIAL
    ----------------------------------- */

    function requiresSpecialShipping(variant) {

      if (!variant) return false;

      var sizeText = normalize(variant.options.join(' '));


      /*
       * IMPORTANTE:
       *
       * Solo analizamos números si la opción
       * realmente parece contener dimensiones.
       *
       * Ejemplos válidos:
       *
       * 100 x 128 cm
       * 120cm x 50cm
       * 75 × 140 cm
       * 59cm x 65cm x 6cm
       *
       * Esto evita interpretar números de años,
       * ediciones, nombres de obras, etc.
       */

      var looksLikeDimensions =
        sizeText.includes('cm') &&
        (
          sizeText.includes(' x ') ||
          sizeText.includes('x') ||
          sizeText.includes('×')
        );

      if (!looksLikeDimensions) {
        return false;
      }


      var dimensions = sizeText.match(/\d+(?:\.\d+)?/g);

      if (!dimensions) return false;


      dimensions = dimensions.map(function (value) {
        return Number(value);
      });


      /*
       * Regla general EDO:
       * cualquier dimensión MAYOR de 120 cm
       * requiere cotización personalizada.
       */

      var exceeds120 = dimensions.some(function (dimension) {
        return dimension > 120;
      });


      /*
       * Excepciones que ya habíamos definido
       * para piezas que requieren manejo especial.
       */

      var specialHandling =
        sizeText.includes('59cm x 65cm x 6cm') ||
        sizeText.includes('60cm x 50cm x 65.8cm');


      return exceeds120 || specialHandling;
    }


    /* -----------------------------------
       ACTUALIZAR BOTÓN
    ----------------------------------- */

    function update() {

      var variant = currentVariant();

      if (!variant) return;


      /*
       * Mantener sincronizado el ID
       * de la variante seleccionada.
       */

      variantInput.value = variant.id;


      /*
       * Shopify sigue siendo quien determina
       * si realmente existe inventario.
       *
       * NO tocamos ni deshabilitamos
       * los botones de variantes del tema.
       */

      var available = variant.available !== false;

      submitButton.disabled = !available;

      submitButton.setAttribute(
        'aria-disabled',
        String(!available)
      );


      if (submitButton.dataset.labelAvailable) {

        submitButton.textContent = available
          ? submitButton.dataset.labelAvailable
          : submitButton.dataset.labelSoldOut;
      }


      if (status) {

        status.textContent = available
          ? ''
          : (submitButton.dataset.labelSoldOut || '');
      }


      /*
       * Determinar si necesita
       * cotización especial.
       */

      var special = requiresSpecialShipping(variant);


      productForm.hidden = special;


      if (freightBox) {
        freightBox.hidden = !special;
      }


      /*
       * Preparar email de cotización.
       */

      if (special && freightEmail) {

        var size = variant.options.join(' / ');

        var subject =
          'Cotización de entrega — ' + document.title;

        var body =
          'Hola, quisiera recibir atención personalizada para la adquisición y entrega de esta obra:\r\n\r\n' +
          'Obra: ' + document.title + '\r\n' +
          'Medida: ' + size + '\r\n\r\n' +
          'Página: ' + window.location.href;


        freightEmail.href =
          'mailto:edomix@edosanabria.com' +
          '?subject=' + encodeURIComponent(subject) +
          '&body=' + encodeURIComponent(body);
      }
    }


    /* -----------------------------------
       ENVÍO DEL FORMULARIO
    ----------------------------------- */

    wrapper.addEventListener('submit', function (event) {

      update();

      var variant = currentVariant();

      if (!variant || submitButton.disabled) {
        event.preventDefault();
      }

    });


    /* -----------------------------------
       CAMBIO DE VARIANTE
    ----------------------------------- */

    document.addEventListener('change', function (event) {

      if (
        event.target.matches(
          'variant-selects select,' +
          'variant-selects input[type="radio"],' +
          'variant-radios input[type="radio"],' +
          'select[name^="options"],' +
          'input[name^="options"]'
        )
      ) {

        requestAnimationFrame(function () {

          requestAnimationFrame(function () {
            update();
          });

        });

      }

    });


    window.addEventListener('popstate', update);


    /* Primera carga */

    update();

  });

});